import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import 'vue3-carousel/dist/carousel.css'
import 'tocbot/dist/tocbot.css'
import VueGtag from 'vue-gtag'
import VueSocialSharing from 'vue-social-sharing'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

loadFonts()

const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueGtag, { config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID } })
  .use(VueSocialSharing)
  .use(VueToast)

// A prerendered page (scripts/seo/prerender.mjs) arrives with its content already in #app.
// Mount only once the first route has resolved, so the page is swapped for the identical live
// one in a single frame instead of flashing the spinner and an empty router-view (layout shift).
if (document.getElementById('app').hasChildNodes()) {
  router.isReady().catch(() => {}).then(() => app.mount('#app'))
} else {
  app.mount('#app')
}